import * as React from 'react';
import {
    BodyLargeRegular,
    Button,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

interface LegacySavingsInviteSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

const LegacySavingsInviteSheet = ({
    isOpen,
    onClose,
}: LegacySavingsInviteSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Invite account owner"
            showCloseButton={false}
            forceKeyboardCompatibleBottomSheet
        >
            <YStack paddingTop={20} gap={20} $sm={{ gap: 40 }}>
                <BodyLargeRegular>
                    If you would like to invite an individual to be a joint
                    account owner for this Fruitful Savings Account, please
                    reach out to support@fruitful.com for assistance.
                </BodyLargeRegular>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    text="Got it"
                    onPress={onClose}
                />
            </YStack>
        </Sheet>
    );
};

export default LegacySavingsInviteSheet;
